<template>
    <span
        class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-text-xs tw-font-medium tw-leading-5"
        :class="[classes, compact ? 'tw-px-1.5 tw-py-0' : 'tw-px-2.5 tw-py-0.5']"
    >
        <slot>{{ status }}</slot>
    </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    type: {
        type: String,
        required: false,
        validator: (value) => {
            return ['primary', 'success', 'warning', 'danger', 'info', 'disabled'].includes(value);
        },
    },
    status: {
        type: String,
        required: false,
        validator: (value) =>
            [
                'Open',
                'Draft',
                'Awaiting Approval',
                'Awaiting Reapproval',
                'Approved',
                'Sent',
                'Complete',
                'Paid',
                'Rejected',
                'Void',
                'Confirmed',
                'TBC',
                'Closed',
                'Overdue',
            ].includes(value),
    },
    rounded: {
        type: Boolean,
        default: true,
    },
    compact: {
        type: Boolean,
        default: false,
    },
});

const classes = computed(() => {
    switch (props.status ?? props.type) {
        case 'primary':
            return 'tw-border-eventwise/20 tw-bg-eventwise/10 tw-text-eventwise';
        case 'success':
        case 'Approved':
        case 'Open':
        case 'Complete':
        case 'Paid':
        case 'Confirmed':
            return 'tw-border-emerald-200 tw-bg-emerald-50 tw-text-emerald-700';
        case 'warning':
        case 'Awaiting Approval':
        case 'Awaiting Reapproval':
            return 'tw-border-amber-200 tw-bg-amber-50 tw-text-amber-700';
        case 'danger':
        case 'Rejected':
        case 'Overdue':
            return 'tw-border-red-200 tw-bg-red-50 tw-text-red-700';
        case 'info':
        case 'Sent':
            return 'tw-border-sky-200 tw-bg-sky-50 tw-text-sky-700';
        case 'disabled':
        case 'Draft':
        case 'Void':
        case 'Closed':
            return 'tw-border-slate-200 tw-bg-slate-50 tw-text-slate-600';
        case 'TBC':
            return 'tw-border-amber-200 tw-bg-amber-50 tw-text-amber-700';
        case 'Team':
            return 'tw-border-blue-200 tw-bg-blue-50 tw-text-blue-700';
        default:
            return 'tw-border-slate-200 tw-bg-white tw-text-slate-600';
    }
});
</script>
